import apiService from './ApiService';

class MensajeriaInternaService {
  async getMensajes({ skip = 0, take = 50, search = '', leido = 'todos' } = {}) {
    const params = new URLSearchParams();
    if (Number.isFinite(skip)) params.append('skip', skip);
    if (Number.isFinite(take)) params.append('take', take);
    if (search) params.append('search', search);
    if (leido) params.append('leido', leido);
    const query = params.toString();
    return apiService.request(`/mensajeria-interna/mensajes${query ? `?${query}` : ''}`, {
      method: 'GET'
    });
  }

  async getMensajesEnviados({ skip = 0, take = 50, search = '' } = {}) {
    const params = new URLSearchParams();
    if (Number.isFinite(skip)) params.append('skip', skip);
    if (Number.isFinite(take)) params.append('take', take);
    if (search) params.append('search', search);
    const query = params.toString();
    return apiService.request(`/mensajeria-interna/mensajes/enviados${query ? `?${query}` : ''}`, {
      method: 'GET'
    });
  }

  async getMensajeEnviadoDetalle(id) {
    if (!id) throw new Error('Mensaje inválido.');
    return apiService.request(`/mensajeria-interna/mensajes/enviados/${id}`, {
      method: 'GET'
    });
  }

  async getNoLeidosCount() {
    return apiService.request('/mensajeria-interna/mensajes/no-leidos/count', {
      method: 'GET'
    });
  }

  async updateLeido(id, leido) {
    if (!id) throw new Error('Mensaje inválido.');
    return apiService.request(`/mensajeria-interna/mensajes/${id}/leido`, {
      method: 'PUT',
      body: { leido: Boolean(leido) }
    });
  }

  async getAdminComposerOptions() {
    return apiService.request('/mensajeria-interna/admin/composer-options', {
      method: 'GET'
    });
  }

  async getAdminFamiliaresComposerOptions() {
    return apiService.request('/mensajeria-interna/admin/familiares/composer-options', {
      method: 'GET'
    });
  }

  async getProfesorComposerOptions() {
    return apiService.request('/mensajeria-interna/profesor/composer-options', {
      method: 'GET'
    });
  }

  async getProfesorFamiliaresComposerOptions() {
    return apiService.request('/mensajeria-interna/profesor/familiares/composer-options', {
      method: 'GET'
    });
  }

  async getAlumnoComposerOptions() {
    return apiService.request('/mensajeria-interna/alumno/composer-options', {
      method: 'GET'
    });
  }

  async enviarMensajeAdmin(payload) {
    return apiService.request('/mensajeria-interna/admin/mensajes', {
      method: 'POST',
      body: payload
    });
  }

  async enviarMensajeFamiliaresAdmin(payload) {
    return apiService.request('/mensajeria-interna/admin/familiares/mensajes', {
      method: 'POST',
      body: payload
    });
  }

  async enviarMensajeProfesor(payload) {
    return apiService.request('/mensajeria-interna/profesor/mensajes', {
      method: 'POST',
      body: payload
    });
  }

  async enviarMensajeFamiliaresProfesor(payload) {
    return apiService.request('/mensajeria-interna/profesor/familiares/mensajes', {
      method: 'POST',
      body: payload
    });
  }

  async enviarMensajeAlumno(payload) {
    return apiService.request('/mensajeria-interna/alumno/mensajes', {
      method: 'POST',
      body: payload
    });
  }
}

const mensajeriaInternaService = new MensajeriaInternaService();

export default mensajeriaInternaService;
